import { render, staticRenderFns } from "./NewOrderFile.vue?vue&type=template&id=7a2ff35d&"
import script from "./NewOrderFile.vue?vue&type=script&lang=js&"
export * from "./NewOrderFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports